const mainRoutes = [{
    path: "*",
    redirect: "/SignIn"
  },
  {
    path: "/",
    redirect: "/SignIn"
  },
  {
    path: "/SignIn",
    name: "SignIn",
    component: require("@/components/SignIn").default,
    meta: {
      requiresAuth: false
    }
  }
];

export default mainRoutes;